import { render, staticRenderFns } from "./importModal.vue?vue&type=template&id=45d4a624"
import script from "./importModal.vue?vue&type=script&lang=js"
export * from "./importModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports